import Vuex from "vuex";
import { shallowMount, createLocalVue } from "@vue/test-utils";
import EditAutoDeliveryCancelReasons from "./EditAutoDeliveryCancelReasons";
import { mutations } from '../../../../../store/modules/subscriptions';

const localVue = createLocalVue();
localVue.use(Vuex);

let clearCancelDataMock = jest.fn();
let editAutoDeliveryPauseModalMock = jest.fn();
let populateSubInEditByIdMock = jest.fn();
let setCancelReasonSpy = jest.spyOn(mutations, 'setCancelReason');
let setCancelCommentMock = jest.fn();
let initSubscriptionsMock = jest.fn();
let routerPushMock = jest.fn();

const storeObj = {
  modules: {
    subscriptions: {
      namespaced: true,
      state: {
        cancelReasons: [],
        cancelData: {
          reason: {},
          comment: null
        }
      },

      actions: {
        clearCancelData: clearCancelDataMock,
        editAutoDeliveryPauseModal: editAutoDeliveryPauseModalMock,
        populateSubInEditById: populateSubInEditByIdMock,
        initSubscriptions: initSubscriptionsMock
      },

      mutations: {
        setCancelReason: mutations.setCancelReason,
        setCancelComment: setCancelCommentMock
      }
    },

    customer: {
      namespaced: true,
      state: {
        info: {}
      }
    },
  }
};

const createWrapper = (storeObj) => {
  let store = new Vuex.Store(storeObj);
  return shallowMount(EditAutoDeliveryCancelReasons, {
    store,
    localVue,
    mocks: {
      $route: {
        params: {
          subId: 234
        }
      },
      $router: {
        push: routerPushMock
      }
    }
  });
};

describe('EditAutoDeliveryCancelReasons', () => {

  describe('computed', () => {
    describe('backUrl', () => {
      let localState = {
        $route: {
          params: {
            subId: 123
          }
        }
      };

      let res = EditAutoDeliveryCancelReasons.computed.backUrl.call(localState);
      expect(res).toEqual('/dashboard/purchases/edit-auto-delivery/123');

      let localState2 = {
        $route: {
          params: {
            subId: 321
          }
        }
      };

      let res2 = EditAutoDeliveryCancelReasons.computed.backUrl.call(localState2);
      expect(res2).toEqual('/dashboard/purchases/edit-auto-delivery/321');
    });

    describe('otherReasonSelected', () => {
      test('return false when no reason in cancelData', () => {
        let localState = {
          otherReasons: [{id: 1}, {id: 2}, {id: 3}],
          cancelData: {
            reason: {}
          }
        };

        let res = EditAutoDeliveryCancelReasons.computed.otherReasonSelected.call(localState);
        expect(res).toBe(false);
      });

      test('return false when reason in cancelData does not match any otherReasons', () => {
        let localState = {
          otherReasons: [{id: 1}, {id: 2}, {id: 3}],
          cancelData: {
            reason: {id: 5}
          }
        };

        let res = EditAutoDeliveryCancelReasons.computed.otherReasonSelected.call(localState);
        expect(res).toBe(false);
      });

      test('return true when reason in cancelData does match any otherReasons', () => {
        let localState = {
          otherReasons: [{id: 1}, {id: 2}, {id: 3}],
          cancelData: {
            reason: {id: 2}
          }
        };

        let res = EditAutoDeliveryCancelReasons.computed.otherReasonSelected.call(localState);
        expect(res).toBe(true);
      });
    });
  });

  describe('methods', () => {
    afterEach(() => {
      clearCancelDataMock.mockClear();
      editAutoDeliveryPauseModalMock.mockClear();
      populateSubInEditByIdMock.mockClear();
      setCancelReasonSpy.mockClear();
      setCancelCommentMock.mockClear();
      initSubscriptionsMock.mockClear();
      routerPushMock.mockClear();
    });

    describe('reasonClick', () => {
      test('call setCancelReason and $router.push with correct route', () => {
        let wrapper = createWrapper(storeObj);
        let clickedReason = {
          id: 7,
          route: 'cancelTooMuch'
        };
        wrapper.vm.reasonClick(clickedReason);
        expect(setCancelReasonSpy).toHaveBeenCalledTimes(1);
        expect(routerPushMock).toHaveBeenCalledTimes(1);
        expect(routerPushMock).toHaveBeenCalledWith({ name: clickedReason.route });
      });

      test('set showOtherReasons to true when cancelData.reason id is "Other"', () => {
        let cancelReason = {
          id: 'Other'
        };

        let wrapper = createWrapper(storeObj);

        wrapper.vm.reasonClick(cancelReason);
        expect(wrapper.vm.showOtherReasons).toBe(true);
      });

      test('set showOtherReasons to true when cancelData.reason id is 4', () => {
        let cancelReason = {
          id: 4
        };
        let wrapper = createWrapper(storeObj);

        wrapper.vm.reasonClick(cancelReason);
        expect(wrapper.vm.showOtherReasons).toBe(true);
      });
    });
  });
});
